
<div class="surface-ground px-4 py-5 md:px-6 lg:px-8">
    
</div>

<div class="surface-section px-4 py-4 md:px-6 lg:px-8 text-center">
    <div class="mb-3 font-bold text-3xl">
        <span class="text-yellow-900">FacturaFacil, </span>
        <span class="text-blue-600">Ecuador</span>
    </div>
    <div class="text-700 mb-6">Plataforma para negocios de personas</div>
    <div class="grid mb-6">
        <div class="col-12 md:col-6 lg:col-3" *ngFor="let indicador of indicadores">
            <div class="surface-card shadow-2 p-3 border-round">
                <div class="flex justify-content-between mb-3">
                    <div>
                        <span class="block text-500 font-medium mb-3">{{ indicador.titulo }}</span>
                        <div class="text-900 font-medium text-xl">{{ indicador.magnitud }}</div>
                    </div>
                    <div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
                        <i class="pi {{ indicador.icono }} text-blue-500 text-xl"></i>
                    </div>
                </div>
                <span class="text-green-500 font-medium"></span>
                <span class="text-500">{{ indicador.unidadMedida }}</span>
            </div>
        </div>
    </div>
    <div class="text-700 mb-6">Vigencia de planes</div>
    <!-- Buscador de suscriptores -->
    <app-suscripcion-buscador></app-suscripcion-buscador>
    
    <div class="text-700 mb-6">Accesos directos</div>
    <div class="grid">
        <div class="col-12 md:col-4 mb-4 px-5">
            <button pButton pRipple
                    type="button"
                    pTooltip="{{ appConfig.ux.actions.download }} {{ 'reportes en excel' }}" tooltipPosition="bottom" 
                    icon="pi pi-bookmark" class="ml-1 p-button-raised"
                    (click)="generateItemsToPDFByReporte($event);"
                    [disabled]="false">
            </button>
<!--            <span class="p-3 shadow-2 mb-3 inline-block surface-card" style="border-radius: 10px">
                <i class="pi pi-desktop text-4xl text-blue-500"></i>
            </span>-->
            <div class="text-900 text-xl mb-3 font-medium">Reportes</div>
            <span class="text-700 line-height-3">Reportes generales de la plataforma</span>
        </div>
        <div class="col-12 md:col-4 mb-4 px-5">
            <button pButton pRipple
                    type="button"
                    pTooltip="Suscripciones" tooltipPosition="bottom" 
                    icon="pi pi-bookmark-fill" class="ml-1 p-button-raised"
                    (click)="irASucripciones();"
                    [disabled]="false">
            </button>
<!--            <span class="p-3 shadow-2 mb-3 inline-block surface-card" style="border-radius: 10px">
                <i class="pi pi-desktop text-4xl text-blue-500"></i>
            </span>-->
            <div class="text-900 text-xl mb-3 font-medium">Suscripciones</div>
            <span class="text-700 line-height-3">Administración de suscripciones</span>
        </div>
    </div>
</div>


<!-- Diálogo de selección de reporte-->
<p-dialog header="Generador de reportes FacturaFácil Ecuador" [(visible)]="mostrarSelectorReporte" 
          [modal]="true" showEffect="fade" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw', height: '600px'}"
          [transitionOptions]="'0ms'" (onHide)="mostrarSelectorReporte=false;">
    <div class="p-col-12 p-md-12 p-lg-12">
        <div class="grid relative">
            <div class="col-12 lg:col-12 text-left align-self-center">
                Fechas:
            </div>
            <div class="col-12 lg:col-4 text-left align-self-center">
                <p-calendar #dtCalendarInit inputId="dtRangeInit"
                            [(ngModel)]="dtRangeInit" 
                            [ngModelOptions]="{standalone: true}"
                            dateFormat="yy/mm/dd"
                            placeholder="Desde..."
                            [showTransitionOptions]="'.18s'" [hideTransitionOptions]="'.3s'"
                            (onSelect)="onFilterDate($event)"
                            (onInput)="onFilterDate($event)">
                </p-calendar>
            </div>
            <div class="col-12 lg:col-4 text-left align-self-center">
                <p-calendar #dtCalendarEnd inputId="dtRangeEnd"
                            [(ngModel)]="dtRangeEnd" 
                            [ngModelOptions]="{standalone: true}"
                            dateFormat="yy/mm/dd"
                            placeholder="Hasta..."
                            [showTransitionOptions]="'.18s'" [hideTransitionOptions]="'.3s'"
                            (onSelect)="onFilterDate($event)"
                            (onInput)="onFilterDate($event)">
                </p-calendar>
            </div>
            <div class="col-12 lg:col-4 text-center align-self-center">
                <div class="p-ml-2 p-mr-2 p-text-bold" style="color: gray;">Último mes: </div>
                <p-toggleButton onIcon="pi pi-check-circle" offIcon="pi pi-circle-off"
                                [(ngModel)]="dtRangeMonth"
                                [ngModelOptions]="{standalone: true}"
                                (onChange)="onFilterDateRange($event)">
                </p-toggleButton>
            </div>
        </div>
    </div>
    <div class="p-col-12 p-md-12 p-lg-12">
        <div class="p-text-bold" style="color: gray;">Documento: </div>
        <p-listbox [options]="catalogoReportes"
                   [metaKeySelection]="false"
                   [(ngModel)]="reporte" optionLabel="name"
                   [ngModelOptions]="{standalone: true}"
                   (onClick)="generarReportePorFiltros($event)"
                   (onDblClick)="generarReportePorFiltros($event)"
                   (onChange)="generarReportePorFiltros($event)"
                   emptyMessage="Aún sin definir reportes..."
                   [filter]="true" emptyFilterMessage="No se encontraron resultados."
                   [listStyle]="{'max-height':'250px'}">
        </p-listbox>
    </div>
</p-dialog>